import React, { Fragment, useRef, useState, useEffect } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom/dist'
import { useCreatePayslips, useGetPayslipDetail, usePayslipUpdate } from '../../actions/payslip-actions'
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import PageTitle from '../layouts/PageTitle'
import { useNavigate } from 'react-router-dom';
import { useGetEmployeeList } from '../../actions/employee-actions';
import { extractFileName } from '../../utils/ComponentUtilse';
import LoadingOverlay from 'react-loading-overlay';


function AddPayslips() {

  const navigate = useNavigate();
  const FormRef = useRef(null);
  const location = useLocation();
  let id = location?.state?.rowId;

  const { data: getAllEmployee } = useGetEmployeeList();
  const { mutate: postNewPayslips, isLoading: loadingPostPayslipFn } = useCreatePayslips();
  const { data: payslipDetail, refetch: refetchEmployeePayslip, isLoading: loadingPayslipFn } = useGetPayslipDetail(location?.state?.rowId);
  const { mutate: patchPayslip, isLoading: loadingPatchPayslipFn } = usePayslipUpdate();

  const [payslipData, setPayslipData] = useState({});
  const [currentAttachmentData, setCurrentAttachmentData] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");

  const handleSubmit = () => {
    let FormValidity = FormRef.current.reportValidity();

    if (!startDate || !endDate) {
      setDateError("Both start date and end date are required.");
      return;
    }

    if (FormValidity === true) {
      if (id) {
        UpdateEmployeePayslipHandeler();
      } else {
        postEmployeePayslipHandeler();
      }
    }
  }

  const postEmployeePayslipHandeler = () => {
    let payslipdata = {
      reporter: payslipData.reporter,
      resource: payslipData.resource,
      start_date: startDate || null,
      end_date: endDate || null,
      total_hours: payslipData.total_hours,
      notes: payslipData.notes,
      number_of_days: payslipData.number_of_days,
      attachment: payslipData.attachment,
    };
    postNewPayslips(payslipdata, {
      onSuccess: () => navigate('/list-payslips/')
    });
  }

  const UpdateEmployeePayslipHandeler = () => {
    let payslipdata = {
      reporter: payslipData.reporter,
      resource: payslipData.resource,
      start_date: startDate || null,
      end_date: endDate || null,
      total_hours: payslipData.total_hours,
      notes: payslipData.notes,
      number_of_days: payslipData.number_of_days,
    };

    if (payslipData?.attachment?.name) {
      payslipdata['attachment'] = payslipData?.attachment;
    }

    patchPayslip({ id, payslipdata }, {
      onSuccess: () => navigate('/list-payslips/')
    });
  }

  const SelectChangeHandler = (e) => {
    const selectedIndex = e.target.selectedIndex;
    const selectName = e.target.name;
    const selectValue = e.target.options[selectedIndex].value;
    setPayslipData({
      ...payslipData,
      [selectName]: selectValue,
    });
  };

  const handleInputChange = (event) => {
    const { name, value, type } = event.target;

    if (type === "file") {
      setPayslipData({
        ...payslipData,
        [name]: event.target.files[0],
      });
      setCurrentAttachmentData(event.target.files[0].name);
    } else if (name === "total_hours" || name === "number_of_days") {
      const regex = /^\d*\.?\d{0,2}$/;
      if (value === "" || regex.test(value)) {
        setPayslipData({ ...payslipData, [name]: value });
      }
    } else {
      setPayslipData({
        ...payslipData,
        [name]: value,
      });
    }
  };

  useEffect(() => {
    if (payslipDetail) {
      setPayslipData(payslipDetail);
      setStartDate(payslipDetail.start_date || "");
      setEndDate(payslipDetail.end_date || "");
      setCurrentAttachmentData(extractFileName(payslipDetail.attachment));
    }
  }, [payslipDetail, id]);

  return (
    <Fragment>
      <PageTitle activeMenu="Settings" motherMenu="Home" />
      <div>
        <div className='col-xl-12 col-xxl-12'>
          <Card className="az-card">
            <Card.Header>
              <h3>{id ? "Edit Payslip" : "Add Payslip"}</h3>
            </Card.Header>
            <LoadingOverlay
              active={loadingPayslipFn && id}
              spinner
              text='Fetching...'
              className="custom-overlay"
            >
              <Card.Body>
                <form ref={FormRef}>
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col className='col-lg-6 mb-2'>
                        <label>Reporter<span className="required">*</span></label>
                        <Form.Select
                          name="reporter"
                          className="form-control"
                          value={payslipData?.reporter}
                          onChange={SelectChangeHandler}
                          required
                        >
                          <option value="">Select Reporter</option>
                          {getAllEmployee?.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.first_name} {option.last_name} {option.employee_number ? ` (${option.employee_number})` : ''}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col className='col-md-6 mb-2'>
                        <label>Employee<span className="required">*</span></label>
                        <Form.Select
                          name="resource"
                          className="form-control"
                          value={payslipData?.resource}
                          onChange={SelectChangeHandler}
                          required
                        >
                          <option value="">Select Resource</option>
                          {getAllEmployee?.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.first_name} {option.last_name} {option.employee_number ? ` (${option.employee_number})` : ''}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Form.Group>

                  {/* Date Fields */}
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col className='col-md-6 mb-2'>
                        <label>Start Date<span className="required">*</span></label>
                        <Form.Control
                          type="date"
                          name="start_date"
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(e.target.value);
                            if (endDate && e.target.value > endDate) {
                              setDateError("Start date cannot be after end date!");
                            } else {
                              setDateError("");
                            }
                          }}
                          required
                        />
                      </Col>
                      <Col className='col-md-6 mb-2'>
                        <label>End Date<span className="required">*</span></label>
                        <Form.Control
                          type="date"
                          name="end_date"
                          value={endDate}
                          min={startDate}
                          onChange={(e) => {
                            if (startDate && e.target.value < startDate) {
                              setDateError("End date cannot be before start date!");
                            } else {
                              setEndDate(e.target.value);
                              setDateError("");
                            }
                          }}
                          required
                        />
                      </Col>
                      {dateError && <p style={{ color: "red", marginTop: "5px" }}>{dateError}</p>}
                    </Row>
                  </Form.Group>

                  {/* Hours & Notes */}
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col className='col-md-6 mb-2'>
                        <label>Total Hours<span className="required">*</span></label>
                        <Form.Control
                          type="number"
                          name='total_hours'
                          placeholder="Total Hours"
                          value={payslipData?.total_hours || ""}
                          onChange={handleInputChange}
                          min="0"
                          step="0.01"
                          required
                          className="no-spinner"
                        />
                      </Col>
                      <Col className='col-md-6 mb-2'>
                        <label>Notes</label>
                        <Form.Control
                          type="text"
                          name='notes'
                          placeholder="Notes"
                          value={payslipData?.notes || ""}
                          onChange={handleInputChange}
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  {/* Days & Attachment */}
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col className='col-md-6 mb-2'>
                        <label>Number of Days<span className="required">*</span></label>
                        <Form.Control
                          type="number"
                          name='number_of_days'
                          placeholder="Number of Days"
                          value={payslipData?.number_of_days || ""}
                          onChange={handleInputChange}
                          min="0"
                          step="0.01"
                          required
                          className="no-spinner"
                        />
                      </Col>
                      <Col className='col-md-6 mb-2'>
                        <label>Attachment (only pdf.)</label>
                        <Form.Control
                          type="file"
                          name="attachment"
                          onChange={handleInputChange}
                          accept=".pdf,application/pdf"
                        />
                        <Row className='col-md-6 mt-3'>
                          <label>Selected File</label>
                          <label>{currentAttachmentData}</label>
                        </Row>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className='mt-2'>
                    <Row>
                      <Col className="col-md-12">
                        <hr />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                          <Button
                            variant="danger light btn-sm"
                            onClick={() => navigate("/list-payslips/")}
                          >
                            Cancel
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            variant="primary btn-sm"
                            onClick={handleSubmit}
                            disabled={(loadingPayslipFn && id) || loadingPostPayslipFn || loadingPatchPayslipFn}
                          >
                            {loadingPostPayslipFn || loadingPatchPayslipFn ? (
                              <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Loading...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                </form>
              </Card.Body>
            </LoadingOverlay>
          </Card>
        </div>
      </div>
    </Fragment>
  )
}

export default AddPayslips
